import { FINISH_UPDATE, HIDE_UPDATE_DIALOG, SHOW_UPDATE_DIALOG } from "../actions/versionState";

const INITIAL_STATE = {
  showUpdateDialog: false,
  // Bool indica si hay una actualización en curso.
  updateInProgress: false,
};

const versionState = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_UPDATE_DIALOG:
      return {
        ...state,
        updateInProgress: true,
        showUpdateDialog: true,
      };
    case HIDE_UPDATE_DIALOG:
      return {
        ...state,
        showUpdateDialog: false,
      };
    case FINISH_UPDATE:
      return {
        ...state,
        updateInProgress: false,
        showUpdateDialog: false,
      }
    default:
      return state;
  }
}
export default versionState;